import { shareEntityButtonStyles } from "@insite/content-library/Components/ShareEntityButton";

shareEntityButtonStyles.button = {
    variant: "secondary",
};
